import script from "./TenantRequestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantRequestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./TenantRequestDetailView.vue?vue&type=style&index=0&id=3172e772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3172e772"]])

export default __exports__